export class HollidayModel {
    id : number;
    descricao : string;
    data : string;
    recorrente : boolean;
}
